import { cache_helper, helper } from './creator/cGameObjects/helper';

import { cDisplay } from './creator/cDisplay';
import { cGame, configDataSet } from './creator/cGame';
import { cScene } from './creator/cScene';
import { net } from './creator/utils/net'
import { displayTypes } from './gameObjects/displayTypes';
import { interfaceDisplay } from './gameObjects/interfaceDisplay';
import { urlVariables } from './utils/net';

import './style.css';
import { md5 } from "./creator/utils/md5";
import { logging } from "./creator/utils/logging";
import { applyStates } from "./applyStates";
import { speechBubble } from "./creator/cDisplayObjects/speechBubble";
import { voiceOver } from "./utils/voiceOver";

class App {
  
  public game: cGame;
  private configData;
  private interface: cScene
  
  constructor(){
    helper.log();
    let urlVars:any = urlVariables();
    net.serverUrl = '';
    net.fetchJson('config.json',{},(data)=>{      
      var s = document.querySelector('body').getAttribute('server')
      net.serverUrl = s.charAt(0) === '{' ? data.server : s
      this.configData = data
      if (urlVars.start) {
        this.configData.startscreen = urlVars.start
        this.configData.showInterface = true
      }
      //this.configData.showInterface = true;
      this.setup();
    });        
  }
 

  handleAction(action,opt){
      //console.log('INDEX ACTION',action,opt)
      switch (action.command){
        case 'goto':
          (this.interface.display as interfaceDisplay).clearHints()
          break;
        case 'scene_completed':
          let n = this.game.state.get('scene_completed',0)          
          if (Number(n) < Number(action.options)){
            this.game.state.set('scene_completed', action.options)
          }
          break;
        case 'store_poster_score':
          var hash = cGame.current.state.get('2::hash','')
          if (hash == ''){
            hash =  md5('kasdj'+ new Date().toISOString() + '')
          }

          var g = cGame.current.state.get('2::posters',[])
          var party = cGame.current.state.get('2::selected_party',[])
          var data = {
            hash: hash + party,
            party: party,
            count: g.length
          }        
          logging.log(net.serverUrl+'/election')
          net.sendJson('POST',net.serverUrl+'/election',data,(r)=>{

          });
          break;

        case 'reset_game':          
          cGame.current.state.remove( action.options +'::')
          cGame.current.state.set('2::currenttask','Noch keine Aufgaben')
          break;
        case 'show_interface':
          (this.interface.display as interfaceDisplay).show( action.options === "true")
          break;
        case 'set_selected_party_name':
          var st = cGame.current.state.get('2::selected_party',"")
          cGame
          break;

        case 'start_interface_timer':
           var [time,overlay] = String(action.options).split(':');
          (this.interface.display as interfaceDisplay).startTimer(Number(time),overlay)
          break

        case 'show_navigation':
          (this.interface.display as interfaceDisplay).showNavigation( action.options === "true")
          break;

        case 'new_task':
          (this.interface.display as interfaceDisplay).handleAction('new_task',action.options);
          break;

        case 'hide_task':
          (this.interface.display as interfaceDisplay).handleAction('hide_task',action.options);
          break;

        case 'validate_wahl_badges':
          var countCompleted = ['2::badge_bunte','2::badge_dss','2::badge_pas','2::badge_qpd','2::badge_tuba','2::badge_ulf'].reduce( (p:any,val)=>{
            var ff = cGame.current.state.get(val,'-')
            var res = (ff === 'show' ? 1 : 0)
            return p + res
          },0);

          if (cGame.current.state.get('2::badge_completed','-') === '-'){
            if (countCompleted === 6){
              cGame.current.state.set('2::badge_completed',1);
              (this.interface.display as interfaceDisplay).handleAction('new_task','$task.goto.wahlomat');
            }
          }          

          break;

        case 'fullscreen':
          var doc:any = window.document;
          var docEl:any = document.querySelector('#holder');
          var requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;
          var cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;      
          if(!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
            requestFullScreen.call(docEl);
          }
          else {
            cancelFullScreen.call(doc);
          }        
          break;
        case 'command':
          break
      }
  }


  
  setup(){
    let config: configDataSet = {
      statename: 'testgame',
      phaser:{
        type: Phaser.AUTO,
        parent: 'holder',
        width: 1920,
        height: 1080,
        backgroundColor: '#def4f4',
        scale:{          
          autoCenter: Phaser.Scale.CENTER_BOTH,
          autoRound: true,
          mode: Phaser.Scale.HEIGHT_CONTROLS_WIDTH,          
          width: 1920,
          height: 1080,
          }
      }
    }      
    
    this.game = new cGame(config);
    this.game.onGoto = (nm)=>{
      var trck = (window as any)._paq
      if (trck){
        trck.push(['trackEvent', 'Goto', nm]);
      }
    }

    this.game.ev.addListener('action',(action, opt)=>{
      this.handleAction(action,opt)
    });


    this.game.ev.addListener('load_start',()=>{
      if (!this.interface || !this.interface.display) return
      (this.interface.display as interfaceDisplay).loadShow(true);
    },this);

    this.game.ev.addListener('load_progress',(val)=>{
      if (!this.interface || !this.interface.display) return
      (this.interface.display as interfaceDisplay).loadProgress(val);
    },this);

    this.game.ev.addListener('load_complete',()=>{
      if (!this.interface || !this.interface.display) return
      (this.interface.display as interfaceDisplay).loadShow(false);
    },this);


    let urlVars:any = urlVariables();
    if (urlVars.state) {
      applyStates(urlVars.state)
    }


    displayTypes.register()


    var s = document.querySelector('body').getAttribute('server')
    if (s.charAt(0) === '{' || String(urlVars.debug) == '1'){
      this.game.state.initDebug()
    }



    this.game.addGlobelScene('_global',()=>{
      var cfg:any = {};
      this.interface = this.game.createScene('_interface',cfg,()=>{
        this.initFirstScreen() 
      });
    })
  }


  initFirstScreen(){
    if (this.configData.startscreen){
      this.game.currentScene = this.game.createScene( this.configData.startscreen,{},()=>{} );

      speechBubble.voiceOver = voiceOver;
      if (this.game.state.get('voiceover',null) == null){
        this.game.state.set('voiceover','on')
      }


      setTimeout( ()=>{
        logging.log('FIRST SGZE',this.configData)
        if (this.configData.showInterface){
          this.handleAction({command:'show_navigation',options:'true'},{});
        } 
      },600)
    }  
  }

}


const ap = new App()
